import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { LabGraph } from "@/Labs/Components/LabGraph";
import { ILabGraphViewProperties, LabGraphState } from "@/Labs/Components/LabGraphView";

class PatientLabGraphView extends BaseReactComponent<ILabGraphViewProperties, LabGraphState> {
    public constructor(props: ILabGraphViewProperties) {
        super(props);

        const initialState = new LabGraphState();
        initialState.StartDate = moment().add("years", -5).startOf("day").toDate();
        initialState.EndDate = moment().endOf("day").toDate();
        this.state = initialState;
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        let checkedGraphsCheckboxes = this.props.GraphModel.get("ObservationTypesCheckBoxes").toArray().filter(x => x.Checked);
        const areDatesValid = moment(this.state.StartDate).isSameOrBefore(this.state.EndDate) || !this.state.StartDate || !this.state.EndDate;
        return (
            <div className="sb-workspace inherit-height">
                <div className="tb ws-scrollable">
                    <div className="labs-graph-container main-content">
                        <div className="tb lab-component-header">
                            <div className="flex-container" style={{ width: "100%", justifyContent: "space-between", marginTop: "10px", marginBottom: "10px" }}>
                                <div />
                                <div style={{ marginRight: "10px" }}>
                                    <strong>{cacheStore.GetString("FromDLabel")} </strong>
                                    <div className="inline-block">
                                        <DateSelector
                                            date={this.state.StartDate}
                                            dateFormat="yyyy-MM-dd"
                                            disabled={false}
                                            id="labGraphStart"
                                            onChangeCallback={date => this.mutateState(s => s.StartDate = date)}
                                            valid={areDatesValid}
                                        />
                                    </div>
                                    <strong style={{ marginLeft: "10px" }}>{cacheStore.GetString("ToM2Label")} </strong>
                                    <div className="inline-block">
                                        <DateSelector
                                            date={this.state.EndDate}
                                            dateFormat="yyyy-MM-dd"
                                            disabled={false}
                                            id="labGraphEnd"
                                            onChangeCallback={date => this.mutateState(s => s.EndDate = date)}
                                            valid={areDatesValid}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="scrollable vertical-scroll-only">
                            {checkedGraphsCheckboxes.map(
                                x => {
                                    let observationValues = this.props.GraphModel.get("Observations")[x.Id];
                                    let obx = x.Model;
                                    return (
                                        <div className="lab-component-container" key={x.Id + "_chart"}>
                                            <LabGraph
                                                StartDate={this.state.StartDate}
                                                EndDate={this.state.EndDate}
                                                MasterObservation={obx}
                                                HeaderText={obx.Text}
                                                ObservationTypeIdentifier={labsStore.GetCleanId(obx.StandardCode)}
                                                Observations={observationValues}
                                            />
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </div>
                </div>
                <div className="ws-subfooter" />
            </div>
        );
    }
}

export { PatientLabGraphView };
